import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

interface NavItem {
  id: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './admin-layout.html'
})
export class AdminLayout {
  private router = inject(Router);

  activeTab = signal('employees');

  // Tab strip order. Reporting / Approval / Team Members lead; the remaining tabs
  // keep their previous relative order behind them.
  navConfig = signal<{ items: NavItem[] }>({
    items: [
      {
        id: 'reporting',
        label: 'Reporting Board',
        icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
      },
      {
        id: 'approval',
        label: 'Approval',
        icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
      },
      {
        id: 'employees',
        label: 'Team Members',
        icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
      },
      {
        id: 'tenants',
        label: 'Tenants',
        icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4'
      },
      {
        id: 'phase-models',
        label: 'Phase Templates',
        icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
      },
      {
        // Route id stays `time-entries`; only the label changed to Export.
        id: 'time-entries',
        label: 'Export',
        icon: 'M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z'
      }
    ]
  });

  constructor() {
    this.updateActiveTab();
  }

  private updateActiveTab() {
    const url = this.router.url;
    if (url.includes('/admin/tenants')) {
      this.activeTab.set('tenants');
    } else if (url.includes('/admin/phase-models')) {
      this.activeTab.set('phase-models');
    } else if (url.includes('/admin/time-entries')) {
      this.activeTab.set('time-entries');
    } else if (url.includes('/admin/approval')) {
      this.activeTab.set('approval');
    } else if (url.includes('/admin/reporting')) {
      this.activeTab.set('reporting');
    } else {
      this.activeTab.set('employees');
    }
  }

  onTabChange(tabId: string) {
    this.activeTab.set(tabId);
    this.router.navigate(['/admin', tabId]);
  }
}
